module.exports = __webpack_public_path__ + "static/media/articlesCard.7fc6bb8d.svg";